import React from "react";
import { useTranslation } from "react-i18next";
import { Slider } from "@material-ui/core";
import "./inputs.css";

const DefaultRangeSlider = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  disabled = false,
  unitLabel,
  error = false,
  helperText = "",
}) => {
  const { t } = useTranslation();

  const numericValue =
    typeof value === "number" && !Number.isNaN(value)
      ? value
      : value === "" || value == null
        ? min
        : Number(value);
  const clamped = Math.min(Math.max(numericValue, min), max);

  const handleChange = (_, newValue) => {
    onChange(newValue);
  };

  const displayUnit = unitLabel ? ` ${t(unitLabel)}` : "";

  return (
    <div className={`DefaultRangeSlider${disabled ? " disabled" : ""}${error ? " error" : ""}`}>
      <span className="DefaultRangeSlider__label">
        {t(label)}
        <span className="DefaultRangeSlider__label-value">
          {clamped}
          {displayUnit}
        </span>
      </span>
      <span className="DefaultRangeSlider__bound">{min}{displayUnit}</span>
      <Slider
        value={clamped}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={handleChange}
        classes={{
          root: "DefaultRangeSlider__slider",
          rail: "DefaultRangeSlider__rail",
          track: "DefaultRangeSlider__track",
          thumb: "DefaultRangeSlider__thumb",
        }}
      />
      <span className="DefaultRangeSlider__bound">{max}{displayUnit}</span>
      {helperText && (
        <span className="DefaultRangeSlider__helper">{t(helperText)}</span>
      )}
    </div>
  );
};

export default DefaultRangeSlider;
